import { defineMessages } from "react-intl";

import { node as $6mwt } from "src/modules/htx/forms/current-cardiological-state/6Mwt";
import { node as cardiopulmonaryStressTest } from "src/modules/htx/forms/current-cardiological-state/cardiopulmonaryStressTest";
import { node as cCt } from "src/modules/htx/forms/current-cardiological-state/cct";
import { node as cMri } from "src/modules/htx/forms/current-cardiological-state/cmri";
import { node as coronarography } from "src/modules/htx/forms/current-cardiological-state/coronarography";
import { node as cPet } from "src/modules/htx/forms/current-cardiological-state/cpet";
import { node as echocardiography } from "src/modules/htx/forms/current-cardiological-state/echocardiography";
import { node as ekg } from "src/modules/htx/forms/current-cardiological-state/ekg";
import { node as heartAssistSystemTherapy } from "src/modules/htx/forms/current-cardiological-state/heartAssistSystemTherapy";
import { node as heartFailureMedicalTherapy } from "src/modules/htx/forms/current-cardiological-state/heartFailureMedicalTherapy";
import { node as hospitalizations } from "src/modules/htx/forms/current-cardiological-state/hospitalizations";
import { node as nyha } from "src/modules/htx/forms/current-cardiological-state/nyha";
import { node as pacemakerTherapy } from "src/modules/htx/forms/current-cardiological-state/pacemakerTherapy";
import { node as rightHeartCatheterization } from "src/modules/htx/forms/current-cardiological-state/rightHeartCatheterization";
import { node as spect } from "src/modules/htx/forms/current-cardiological-state/spect";
import { node as vitalSigns } from "src/modules/htx/forms/current-cardiological-state/vitalSigns";
import { ParentNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	title: {
		id: "form.current_cardiological_state",
		defaultMessage: "Aktuális kardiológiai állapot"
	}
});

export const node: ParentNode = {
	id: "currentCardiologicalState",
	value: { type: "wizard", title: messages.title },
	children: [
		nyha,
		$6mwt,
		vitalSigns,
		hospitalizations,
		ekg,
		echocardiography,
		coronarography,
		cardiopulmonaryStressTest,
		rightHeartCatheterization,
		heartFailureMedicalTherapy,
		pacemakerTherapy,
		heartAssistSystemTherapy,
		cCt,
		cMri,
		spect,
		cPet
	]
};
